var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"align-h":"center"}},[_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.logout}},[_vm._v("Sair")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }